import { faVoteYea } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleIcon from './CircleIcon';
import './Icon.scss';

const VoteIcon = (): JSX.Element => {
  return (
    <CircleIcon>
      <FontAwesomeIcon icon={faVoteYea} size="sm" />
    </CircleIcon>
  );
};

export default VoteIcon;
